<template>
    <el-row>
        <el-col :md="{span: 18, offset: 3}" :lg="{span: 18, offset: 3}" :xl="{span: 18, offset: 3}">
            <div class="news-text-box">
                <el-carousel direction="vertical">
                    <el-carousel-item v-for="item in news" :key="item.id">
                        <div class="news-div">
                            <div class="news-div-T">资讯动态<span class="news-div-TY">INFORMATION</span></div>
                            <div class="news-div-D">
                                <el-col :span="20">
                                    <div class="news-div-DD"><span class="news-div-DR">最新动态：</span>{{item.title}}
                                    </div>
                                </el-col>
                                <el-col :span="4">
                                    <router-link :to="{path:'/information/details',query:{newsId:item.id}}">
                                        <img class="news-div-img" src="../../../static/image/main/mainMore.png">
                                    </router-link>
                                </el-col>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </el-col>
    </el-row>
</template>

<script>
export default {
  name: 'News',
  data() {
    return {
      news: [{title:'索康与广东省医学会整形外科学分会学术会议达成独家合作',id:-1},
        {title:'巅峰论鼻，索康协办广州鼻整形精英学术峰会',id:-2},
        {title:'索康热衷公益，全力协办武汉唇裂鼻修复研讨会',id:-3}]
    }
  },
  created() {
    this.$store.dispatch('news/findMainList').then((res) => {
      // let NEWSLIST=res
      // this.$store.commit('news/NEWSLIST', NEWSLIST)
      // console.log(this.$store.state.news.newsList)
      this.news = res
      // console.log(res)
    })
  },
  methods: {

  }
}
</script>

<style scoped>

</style>

<style>
    .news-text-box{
        margin-bottom: 20px;
    }

    .news-div {
        width: 100%;
        background-color: #f1f1f1;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: self-start;
        font-family: SY-Light;
        color: #a3a3a3;
        font-size: 18px;
    }

    .news-div-D {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin: 20px 0;
    }

    .news-div-T {
        font-size: 24px;
        color: #430098;
        margin: 10px 0 0 20px;
    }

    .news-div-TY {
        font-family: Futura-LT-Book;
        margin: 28px;
    }

    .news-div-DD {
        margin-left: 20px;
    }

    .news-div-DR {
        color: #f84356;
    }

    .news-div-img {
        width: 60%;
    }

    .news-div-DI {
        margin-right: 5%;
    }

    @media screen and (max-width: 750px) {
        .news-text-box > .el-carousel--vertical .el-carousel__container {
            height: 140px;
        }
    }

    @media screen and (max-width: 380px) {
        .news-text-box > .el-carousel--vertical .el-carousel__container {
            height: 230px;
        }
    }

    @media screen and (min-width: 750px) {
        .news-text-box > .el-carousel--vertical .el-carousel__container {
            height: 122px;
        }
    }
</style>
